// extracted by mini-css-extract-plugin
export var root = "gc8K";
export var rootIcon = "eD7N";
export var rootIconWrapper = "sV8b";